import React from 'react'
import { Input } from 'antd'
import styled from 'styled-components'

interface SoapInputProps {
  label: string
  value: string
  onChange?: (v: string) => void

  height?: number
  readOnly?: boolean

  cardStyle?: React.CSSProperties
  labelStyle?: React.CSSProperties
  wrapperStyle?: React.CSSProperties
  textAreaStyle?: React.CSSProperties

  className?: string
}

// =============== BASE STYLES (DEFAULTS) ===============
const Card = styled.div`
  width: 100%;
  border: 1px solid #000000;
  background: transparent;
  border-radius: 6px;
  position: relative;
`

const FloatingLabel = styled.div`
  position: absolute;
  height: 16px;
  width: auto;
  top: -8px;
  left: 10px;
  z-index: 10;
  background: #fffafa;
  padding: 2px 6px;
  border-radius: 4px;
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`

const InputWrapper = styled.div<{ $height: number }>`
  position: relative;
  width: 100%;
  height: ${(p) => `${p.$height}px`};
`

// =============== COMPONENT ===============
const SoapInput: React.FC<SoapInputProps> = ({
  label,
  value,
  onChange,
  height = 193.25,
  readOnly = false,

  cardStyle,
  labelStyle,
  wrapperStyle,
  textAreaStyle,
  className,
}) => {
  return (
    <Card className={className} style={cardStyle}>
      <FloatingLabel style={labelStyle}>{label}</FloatingLabel>

      <InputWrapper $height={height} style={wrapperStyle}>
        <Input.TextArea
          readOnly={readOnly}
          bordered={false}
          style={{
            height: '100%',
            resize: 'none',
            paddingTop: '10px',
            paddingLeft: '15px',
            paddingRight: '15px',
            boxShadow: 'none',
            cursor: readOnly ? 'default' : 'text',
            background: readOnly ? 'transparent' : undefined,
            ...textAreaStyle,
          }}
          value={value}
          onChange={(e) => !readOnly && onChange?.(e.target.value)}
        />
      </InputWrapper>
    </Card>
  )
}

export default SoapInput
